// Sub-menu toggle (accordion par groupe)

const isMobile = () => window.innerWidth < 1024;

function openMenu(menu) {
	menu.style.height = menu.scrollHeight + "px";
}

function closeMenu(menu) {
	// Fixer la hauteur actuelle avant de transitionner vers 0
	menu.style.height = menu.scrollHeight + "px";
	menu.offsetHeight; // force reflow
	menu.style.height = "0";
}

function setAriaStates(trigger, menu, isOpen) {
	trigger.setAttribute("aria-expanded", isOpen);
	menu.setAttribute("aria-hidden", !isOpen);
}

const initSubMenuToggle = () => {
	const triggers = document.querySelectorAll("[data-toggle-target]");

	triggers.forEach((trigger) => {
		trigger.addEventListener("click", (e) => {
			e.preventDefault();
			e.stopPropagation();

			const targetId = trigger.dataset.toggleTarget;
			const menu = document.querySelector(`[data-toggle-menu="${targetId}"]`);

			if (!menu) return;

			const parentItem = menu.parentElement;
			if (!parentItem) return;

			const isOpen = parentItem.classList.contains("is-open");

			// Trouver le groupe depuis l'ancêtre le plus proche
			const groupEl = trigger.closest("[data-toggle-group]");
			const group = groupEl ? groupEl.dataset.toggleGroup : null;

			// Fermer les autres du même groupe (accordéon)
			if (group) {
				const groupContainer = groupEl.parentElement;
				if (groupContainer) {
					groupContainer
						.querySelectorAll(`[data-toggle-group="${group}"]`)
						.forEach((sibling) => {
							if (sibling === groupEl) return;
							if (sibling.classList.contains("is-open")) {
								sibling.classList.remove("is-open");
								const siblingTrigger = sibling.querySelector("[data-toggle-target]");
								const siblingMenu = sibling.querySelector("[data-toggle-menu]");
								if (siblingMenu) {
									if (siblingTrigger) setAriaStates(siblingTrigger, siblingMenu, false);
									if (isMobile()) closeMenu(siblingMenu);
								}
							}
						});
				}
			}

			// Toggle le parent cliqué
			if (!isOpen) {
				parentItem.classList.add("is-open");
				setAriaStates(trigger, menu, true);
				if (isMobile()) openMenu(menu);
			} else {
				parentItem.classList.remove("is-open");
				setAriaStates(trigger, menu, false);
				if (isMobile()) closeMenu(menu);
			}
		});
	});

	// Remettre height: auto après la transition (pour que le contenu reste flexible)
	document.querySelectorAll("[data-toggle-menu]").forEach((menu) => {
		menu.addEventListener("transitionend", (e) => {
			if (e.propertyName !== "height") return;
			if (
				menu.parentElement &&
				menu.parentElement.classList.contains("is-open")
			) {
				menu.style.height = "auto";
			}
		});
	});

	// Fermer tout au clic en dehors
	document.addEventListener("click", (e) => {
		if (
			!e.target.closest("[data-toggle-target]") &&
			!e.target.closest("[data-toggle-menu]")
		) {
			document.querySelectorAll("[data-toggle-menu]").forEach((menu) => {
				if (
					menu.parentElement &&
					menu.parentElement.classList.contains("is-open")
				) {
					menu.parentElement.classList.remove("is-open");
					const menuTrigger = menu.parentElement.querySelector("[data-toggle-target]");
					if (menuTrigger) setAriaStates(menuTrigger, menu, false);
					if (isMobile()) closeMenu(menu);
				}
			});
		}
	});
};

export { initSubMenuToggle };
